<app-base-header
    [version]="version"
    [userName]="userName()"
    [userInfo]="userInfo()"
    [userInitials]="userInitials()"
    [isAdmin]="isAdmin()"
>
    <!-- Desktop interactive items -->
    <ng-container desktopItems>
        <a
            href="https://healthineersnam.sharepoint.com/sites/TheDrive"
            target="_blank"
            class="hidden md:block no-underline hover:no-underline text-sm text-shui-text-subtle hover:text-shui-text-subtle"
        >
            {{ 'common.header.siemens-healthineers-link' | translate }}
        </a>
        <span class="cursor-pointer text-shui-text-subtle flex items-center gap-2" (click)="openContactDialog()">
            <sh-icon icon="mail" size="s" class="text-shui-text-subtle"></sh-icon>
            {{ 'common.header.contact' | translate }}
        </span>
        <app-settings-menu></app-settings-menu>
    </ng-container>

    <!-- Mobile interactive items -->
    <ng-container mobileItems>
        <span class="cursor-pointer text-shui-text-subtle flex items-center gap-2 py-2" (click)="openContactDialog()">
            <sh-icon icon="mail" size="s" class="text-shui-text-subtle"></sh-icon>
            {{ 'common.header.contact' | translate }}
        </span>
        <span
            class="cursor-pointer text-shui-text-subtle flex items-center gap-2 py-2"
            [routerLink]="['settings/user']"
        >
            <sh-icon icon="settings" size="s" class="text-shui-text-subtle"></sh-icon>
            {{ 'common.header.user-settings' | translate }}
        </span>
    </ng-container>
</app-base-header>
